import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"icon-close\"><path fill=\"#ADB1B8\" d=\"M10.879 11.808 6 6.929l-4.878 4.879a.657.657 0 1 1-.93-.93L5.073 6 .191 1.122a.657.657 0 0 1 .93-.93L6 5.071 10.88.192a.657.657 0 1 1 .928.93L6.93 6l4.877 4.878a.657.657 0 0 1-.928.93Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol